@let etatStr = etat() | convertEtatSequenceToString;
<div [class]="_computedClass()">
  <span>{{ etatStr }}</span>
</div>
